/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable max-lines-per-function */
import { type State } from '@hookstate/core'
import { LoadingButton } from '@mui/lab'
import { Button, Collapse, Grid } from '@mui/material'
import React from 'react'
import { useHookstate } from '@hookstate/core'
import FilterAutocompleteFetch from '~/components/FilterAutocompleteFetch'
import { DispatchSearchBox } from '~/components/DispatchSearchBox'
import FilterSelectPeriod from '~/components/FilterAutocompletePeriod'
import { useLang } from '~/hooks/useLang'
import { PrintOccurrenceFilters } from '../interfaces'

interface AuditPrintOccurrenceFiltersProps {
  readonly hidden?: boolean
  readonly labelButton?: State<string>
  readonly loadingButton: State<boolean>
  readonly resetValues?: State<boolean>
  readonly focusChange?: State<boolean>
  readonly userId?: State<number | null>
  readonly IdDispatch?: State<number | null>
  readonly initialPeriod: State<string>
  readonly onPeriodChange: (value: string) => void
  readonly onStartDateChange: (value: string | null) => void
  readonly onFinishDateChange: (value: string | null) => void
  readonly clearFilters: () => void
  readonly searchButton?: (filters?: PrintOccurrenceFilters) => void
  readonly action: State<string | null>
}

export default function AuditPrintOccurrenceFilters({
  hidden,
  labelButton,
  loadingButton,
  userId,
  resetValues,
  focusChange,
  initialPeriod,
  onStartDateChange,
  onFinishDateChange,
  onPeriodChange,
  clearFilters,
  searchButton,
  
  action,
  IdDispatch,
}: AuditPrintOccurrenceFiltersProps) {
  const { translate } = useLang()

  const isOpen = useHookstate(true)

  

  const [startDate, setStartDate] = React.useState<string | null>(null)
  const [finishDate, setFinishDate] = React.useState<string | null>(null)

  function applyFilters() {
  const filters: PrintOccurrenceFilters = {
      start_date: startDate ?? undefined,
      finish_date: finishDate ?? undefined,
      user_id: userId?.get() ?? undefined,
      action: action?.get() ?? undefined,
  
      dispatch_id: IdDispatch?.get() ?? undefined,
    }
    const filtered = Object.fromEntries(
      Object.entries(filters).filter(([, value]) => value !== undefined)
  ) as unknown as PrintOccurrenceFilters
    searchButton?.(filtered)
  }

  return (
    <Collapse in={hidden}>
      <Grid
        container
        xs={12}
        sx={{ width: '100%', display: 'flex', alignItems: 'center' }}
      >
        <Grid container direction={'column'} display={'flex'} gap={1}>
          <Grid container direction={'row'} flexWrap={'wrap'}>

            <Grid item xs={2} sx={{ pl: 1, pt: 1 }}>
              <FilterAutocompleteFetch
                label={translate('User')}
                urlFetch={'/user/get'}
                dataRequest={'user'}
                size={'small'}
                disabled={false}
                onFetchChange={(user: number | null) => userId?.set(user)}
                resetValues={resetValues?.get()}
                focusChange={focusChange}
                valueId={userId?.get() ? Number(userId?.get()) : undefined}
              />
            </Grid>

            

            <Grid item xs={2} sx={{ pl: 1, pt: 1 }}>
              <DispatchSearchBox
                isOpen={isOpen}
                isValid={true}
                isReport={true}
                dispatchId={IdDispatch}
                size={'small'}
                placeholder={translate('Nº Occurrence')}
              />
            </Grid>



            <FilterSelectPeriod
              onStartDateChange={(value) => {
                const json = value?.toJSON() ?? null
                setStartDate(json)
                onStartDateChange(json)
              }}
              onFinishDateChange={(value) => {
                const json = value?.toJSON() ?? null
                setFinishDate(json)
                onFinishDateChange(json)
              }}
              onPeriodChange={onPeriodChange}
              period={initialPeriod.get()}
              xsDateBetween={2}
              xsPeriod={2}
              hidePeriod={false}
              marginDateBetween={0}
              disableFuture={false}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid
        container
        direction={'row'}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'end',
          pt: 4,
          gap: 2,
        }}
      >
        <Button
          variant="outlined"
            onClick={() => {
            clearFilters()
            IdDispatch?.set?.(null)
          }}
        >
          {translate('Clear Filters')}
        </Button>
        <LoadingButton
          loading={loadingButton.get()}
          variant="contained"
          onClick={applyFilters}
        >
          {labelButton?.get()}
        </LoadingButton>
      </Grid>
    </Collapse>
  )
}
